/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignalsRouteImport } from './routes/signals'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as MusicbrainzRouteImport } from './routes/musicbrainz'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as CrateRouteImport } from './routes/crate'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as AppsRouteImport } from './routes/apps'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StationNaddrRouteImport } from './routes/station.$naddr'
import { Route as ProfilePubkeyRouteImport } from './routes/profile.$pubkey'
import { Route as BrowseGenresRouteImport } from './routes/browse.genres'

const SignalsRoute = SignalsRouteImport.update({
  id: '/signals',
  path: '/signals',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const MusicbrainzRoute = MusicbrainzRouteImport.update({
  id: '/musicbrainz',
  path: '/musicbrainz',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const CrateRoute = CrateRouteImport.update({
  id: '/crate',
  path: '/crate',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityRoute = CommunityRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsRoute = AppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StationNaddrRoute = StationNaddrRouteImport.update({
  id: '/station/$naddr',
  path: '/station/$naddr',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilePubkeyRoute = ProfilePubkeyRouteImport.update({
  id: '/profile/$pubkey',
  path: '/profile/$pubkey',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowseGenresRoute = BrowseGenresRouteImport.update({
  id: '/browse/genres',
  path: '/browse/genres',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/apps': typeof AppsRoute
  '/community': typeof CommunityRoute
  '/crate': typeof CrateRoute
  '/favorites': typeof FavoritesRoute
  '/musicbrainz': typeof MusicbrainzRoute
  '/settings': typeof SettingsRoute
  '/signals': typeof SignalsRoute
  '/browse/genres': typeof BrowseGenresRoute
  '/profile/$pubkey': typeof ProfilePubkeyRoute
  '/station/$naddr': typeof StationNaddrRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/apps': typeof AppsRoute
  '/community': typeof CommunityRoute
  '/crate': typeof CrateRoute
  '/favorites': typeof FavoritesRoute
  '/musicbrainz': typeof MusicbrainzRoute
  '/settings': typeof SettingsRoute
  '/signals': typeof SignalsRoute
  '/browse/genres': typeof BrowseGenresRoute
  '/profile/$pubkey': typeof ProfilePubkeyRoute
  '/station/$naddr': typeof StationNaddrRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/apps': typeof AppsRoute
  '/community': typeof CommunityRoute
  '/crate': typeof CrateRoute
  '/favorites': typeof FavoritesRoute
  '/musicbrainz': typeof MusicbrainzRoute
  '/settings': typeof SettingsRoute
  '/signals': typeof SignalsRoute
  '/browse/genres': typeof BrowseGenresRoute
  '/profile/$pubkey': typeof ProfilePubkeyRoute
  '/station/$naddr': typeof StationNaddrRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/apps'
    | '/community'
    | '/crate'
    | '/favorites'
    | '/musicbrainz'
    | '/settings'
    | '/signals'
    | '/browse/genres'
    | '/profile/$pubkey'
    | '/station/$naddr'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/apps'
    | '/community'
    | '/crate'
    | '/favorites'
    | '/musicbrainz'
    | '/settings'
    | '/signals'
    | '/browse/genres'
    | '/profile/$pubkey'
    | '/station/$naddr'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/apps'
    | '/community'
    | '/crate'
    | '/favorites'
    | '/musicbrainz'
    | '/settings'
    | '/signals'
    | '/browse/genres'
    | '/profile/$pubkey'
    | '/station/$naddr'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AppsRoute: typeof AppsRoute
  CommunityRoute: typeof CommunityRoute
  CrateRoute: typeof CrateRoute
  FavoritesRoute: typeof FavoritesRoute
  MusicbrainzRoute: typeof MusicbrainzRoute
  SettingsRoute: typeof SettingsRoute
  SignalsRoute: typeof SignalsRoute
  BrowseGenresRoute: typeof BrowseGenresRoute
  ProfilePubkeyRoute: typeof ProfilePubkeyRoute
  StationNaddrRoute: typeof StationNaddrRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signals': {
      id: '/signals'
      path: '/signals'
      fullPath: '/signals'
      preLoaderRoute: typeof SignalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/musicbrainz': {
      id: '/musicbrainz'
      path: '/musicbrainz'
      fullPath: '/musicbrainz'
      preLoaderRoute: typeof MusicbrainzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crate': {
      id: '/crate'
      path: '/crate'
      fullPath: '/crate'
      preLoaderRoute: typeof CrateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/station/$naddr': {
      id: '/station/$naddr'
      path: '/station/$naddr'
      fullPath: '/station/$naddr'
      preLoaderRoute: typeof StationNaddrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$pubkey': {
      id: '/profile/$pubkey'
      path: '/profile/$pubkey'
      fullPath: '/profile/$pubkey'
      preLoaderRoute: typeof ProfilePubkeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse/genres': {
      id: '/browse/genres'
      path: '/browse/genres'
      fullPath: '/browse/genres'
      preLoaderRoute: typeof BrowseGenresRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AppsRoute: AppsRoute,
  CommunityRoute: CommunityRoute,
  CrateRoute: CrateRoute,
  FavoritesRoute: FavoritesRoute,
  MusicbrainzRoute: MusicbrainzRoute,
  SettingsRoute: SettingsRoute,
  SignalsRoute: SignalsRoute,
  BrowseGenresRoute: BrowseGenresRoute,
  ProfilePubkeyRoute: ProfilePubkeyRoute,
  StationNaddrRoute: StationNaddrRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
